import React from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import Home from './pages/Home';
import About from './pages/About';
import Episodes from './pages/Episodes';
import Contact from './pages/Contact';
import NotFound from './pages/NotFound';
import Privacy from './pages/Privacy';
import Terms from './pages/Terms';
import Guests from './pages/Guests';
import PageTransition from './components/PageTransition';

const AppRoutes = () => {
  const location = useLocation();

  const withPageTransition = (Component) => (
    <PageTransition key={location.pathname}>
      <Component />
    </PageTransition>
  );

  return (
    <Routes>
      <Route path="/" element={withPageTransition(Home)} />
      <Route path="/about" element={withPageTransition(About)} />
      <Route path="/episodes" element={withPageTransition(Episodes)} />
      <Route path="/guests" element={withPageTransition(Guests)} />
      <Route path="/contact" element={withPageTransition(Contact)} />
      <Route path="/privacy" element={withPageTransition(Privacy)} />
      <Route path="/terms" element={withPageTransition(Terms)} />
      <Route path="*" element={withPageTransition(NotFound)} />
    </Routes>
  );
};

export default AppRoutes;
